import { makeObservable, observable, runInAction } from "mobx";
import { AppStore } from "../../stores/AppStore";

export class LandingController {
  store: AppStore;
  showLateEntryModal: boolean = false;
  showInfoModal: boolean = false;
  selectedEvent: any = null;
  eventsLoading: boolean = false;
  eventsError: boolean = false;

  constructor(store: any) {
    this.store = store;

    makeObservable(this, {
      showLateEntryModal: observable,
      showInfoModal: observable,
      selectedEvent: observable,
      eventsLoading: observable,
      eventsError: observable,
    });
  }

  loadEvents = async () => {
    runInAction(() => {
      this.eventsLoading = true;
      this.eventsError = false;
    });

    try {
      await this.store.loadEvents();
    } catch (err) {
      runInAction(() => {
        this.eventsError = true;
      });
    } finally {
      runInAction(() => {
        this.eventsLoading = false;
      });
    }
  };
}
